module.exports = __webpack_public_path__ + "img/coupons.d184d63c.svg";